import { render } from "./ProjectNode.vue?vue&type=template&id=8c8d8154&scoped=true&ts=true"
import script from "./ProjectNode.vue?vue&type=script&lang=ts"
export * from "./ProjectNode.vue?vue&type=script&lang=ts"

import "./ProjectNode.vue?vue&type=style&index=0&id=8c8d8154&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8d8154"]])

export default __exports__